"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = () => {
    var _a;
    const theme = (0, material_1.useTheme)();
    const boxStyles = {
        borderBottom: `1px solid ${theme.qlub.palette.dim.main}`,
    };
    const tabStyles = {
        '&.Mui-selected': {
            color: `${theme.qlub.palette.iris.main} `,
        },
        padding: '8px 16px 10px',
    };
    const tabTextStyles = Object.assign(Object.assign({}, theme.qlub.typography.button), { color: (_a = theme.qlub) === null || _a === void 0 ? void 0 : _a.palette.onSurfaceColors.disabled, fontSize: '14px', textTransform: 'none', fontFamily: 'inherit', padding: 0 });
    const containerBoxStyles = {
        width: '100%',
    };
    const stickyStyles = {
        position: 'sticky',
        top: 0,
        backgroundColor: theme.qlub.palette.white.main,
        zIndex: 10,
    };
    return {
        boxStyles,
        tabStyles,
        tabTextStyles,
        containerBoxStyles,
        stickyStyles,
    };
};
exports.default = useStyle;
